import React from 'react';
import * as Styled from './ALabel.styles';
import { ALabelSize, type ALabelProps } from './ALabel.types';
import clsx from 'clsx';

const COMPONENT_NAME = 'a-web-ui-kit-ALabel';
const TEST_ID = 'web-ui-kit-ALabel';

function ALabel({ size = ALabelSize.S, text, className, ...rest }: ALabelProps) {
  return (
    <Styled.ALabelWrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      size={size}
      className={clsx(className, 'm-ellipsis-1line')}
      {...rest}
    >
      {text}
    </Styled.ALabelWrapper>
  );
}

export { ALabel, ALabelSize, TEST_ID as A_LABEL_TEST_ID };
